import { Injectable } from '@angular/core';

@Injectable()
export class UnsavedStateService {

    constructor() { }

    unsavedStore: Array<String> = [];

    saved(key: string) {
        let index = this.unsavedStore.indexOf(key);

        if (index !== -1) {
            this.unsavedStore.splice(index, 1);
        }
    }

    unsaved(key: string) {
        let index = this.unsavedStore.indexOf(key);

        if (index === -1) {
            this.unsavedStore.push(key);
        }
    }

    isUnsaved() {
        return this.unsavedStore.length !== 0;
    }

    reset() {
        this.unsavedStore = [];
    }
}
